import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { PlanoSaudeProcedimentoPk } from '../../plano-saude/pks/plano-saude-procedimento-pk';
import { PlanoSaude } from '../../plano-saude/plano-saude';
import { PlanoSaudeProcedimento } from '../../plano-saude/plano-saude-procedimento';
import { PlanoSaudeService } from '../../plano-saude/plano-saude.service';
import { ProcedimentoService } from '../../procedimento/procedimento.service';
import { AbastractAssociacao } from '../abstract.associacao';

@Component({
  selector: 'app-associacao-plano-saude-procedimento',
  templateUrl: '../associacao.component.html',
  styleUrls: ['../associacao.component.css']
})
export class AssociacaoPlanoSaudeProcedimentoComponent extends AbastractAssociacao {

  constructor(private planoSaudeService: PlanoSaudeService,
    private procedimentoService: ProcedimentoService,
    formBuilder: FormBuilder,
    dialog: MatDialog) {

    super(formBuilder, dialog);

  }

  ngOnInit() {

    super.ngOnInit();

    this.tituloAssociacao = 'Associação Plano Saúde x Procedimento';
    this.nomeCampoAssociacaoPai = 'Plano Saúde';
    this.nomeCampoAssociacaoFilho = 'Procedimento';

    this.configurarForm();
  }

  getListaDePais(): Observable<any> {

    return this.planoSaudeService.listarPlanoSaudeComRelacaoMinimaDeProcedimento(false, true);

  }

  getListaDeFilhos(): Observable<any> {

    return this.procedimentoService.listarComProjecao();

  }

  getListaDeFilhosSelecionados(): any {

    return (this.associacaoPai as PlanoSaude).planoSaudeProcedimento;

  }

  getIdFilhoFromAssociacaoComPai(currentAssociacao: any): any {

    return currentAssociacao.pk.idProcedimento;
  }

  configurarAssociacoesFilhas(associacoesFilhas: any): void {

    let pai: PlanoSaude = this.associacaoPai as PlanoSaude;

    pai.planoSaudeProcedimento = [];

    if (associacoesFilhas) {

      associacoesFilhas.forEach((currentFilho: any) => {
        pai.planoSaudeProcedimento.push(this.getAssociacaoPaiFilho(currentFilho));
      });

    }
  }

  getAssociacaoPaiFilho(currentFilho: any): any {

    const associacao: PlanoSaudeProcedimento = new PlanoSaudeProcedimento();
    associacao.pk = new PlanoSaudeProcedimentoPk();
    associacao.pk.idPlanoSaude = this.associacaoPai.id;
    associacao.pk.idProcedimento = currentFilho.id;

    return associacao;

  }

  salvarAssociacao(value: any): Observable<Object> {

    return this.planoSaudeService.atualizaRelacaoPlanoSaudeProcedimento(value);
  }

}
